"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
const OneTxPaymentDeployerFactory_1 = require("../contracts/1/OneTxPaymentDeployerFactory");
const getOneTxPaymentDeployerClient = (network, signerOrProvider, address) => {
    const oneTxPaymentFactoryAddress = address || constants_1.oneTxPaymentFactoryAddresses[network];
    if (!oneTxPaymentFactoryAddress) {
        throw new Error(`Could not get OneTxPaymentFactory address for ${network}. Please specify`);
    }
    const oneTxPaymentClient = OneTxPaymentDeployerFactory_1.OneTxPaymentDeployerFactory.connect(oneTxPaymentFactoryAddress, signerOrProvider);
    oneTxPaymentClient.clientType = constants_1.ClientType.OneTxPaymentClient;
    return oneTxPaymentClient;
};
exports.default = getOneTxPaymentDeployerClient;
